/** Тексты копилота. Отдельный словарь: раздел новый и живёт сам по себе. */
export const copilotTexts = {
  title: 'Копилот',
  subtitle: 'Отвечает по таблице',
  open: 'Спросить по таблице',
  close: 'Свернуть',
  send: 'Спросить',
  newChat: 'Новый разговор',
  history: 'Мои разговоры',
  historyEmpty: 'Прошлых разговоров пока нет',
  historyLoading: 'Загружаю…',
  deleteChat: 'Удалить разговор',
  thinking: 'Смотрю таблицу…',
  pondering: 'Думаю над ответом',
  elapsed: (sec: number) => (sec < 60 ? `${sec} с` : `${Math.floor(sec / 60)} мин ${sec % 60} с`),
  failed: 'Не удалось получить ответ',
  placeholder: 'Спросите о брендах, тирах, ссылках…',
  intro: 'Отвечаю по текущим данным таблицы — по опубликованным, без черновиков. Спрашивайте как коллегу.',
  note: 'Enter — спросить, Shift+Enter — перенос строки',
  samples: [
    'Сколько брендов с тиром A+ в Рознице?',
    'У каких брендов в Опте нет адреса страницы?',
    'Где приоритет SEO и Контекста различаются?',
  ],
} as const
